import AuthService from "./axiosInstance";
import endpoints from "./endpoints";

const jurisdictionApi = {

  async getJurisdictions(params = {}) {
    const res = await AuthService.get(endpoints.JURISDICTIONS, { params });
    return res.data;
  },

  async getJurisdictionsSimple(params = {}) {
    const res = await AuthService.get(endpoints.JURISDICTIONS_SIMPLE, { params });
    return res.data;
  },

  async getJurisdiction(canonicalKey) {
    const res = await AuthService.get(
      endpoints.JURISDICTION_DETAIL(canonicalKey)
    );
    return res.data;
  },
};

export default jurisdictionApi;
